import { ReactNode } from 'react';

import { tv } from 'tailwind-variants';

import cn from '@/helpers/utils/classNames';

interface TextSmallProps {
  children: ReactNode;
  className?: string;
  variant?:
    | 'primary'
    | 'secondary'
    | 'light'
    | 'dark'
    | 'dark-red'
    | 'light-gray'
    | 'medium-gray'
    | 'dark-gray'
    | 'silver'
    | 'orange'
    | 'danger';
}

export const textSmallStyles = tv({
  variants: {
    color: {
      primary: 'v2-text-primary',
      secondary: 'v2-text-secondary-light',
      light: 'v2-text-white',
      dark: 'v2-text-black',
      orange: 'v2-text-orange-400',
      'dark-red': 'v2-text-dark-red',
      'light-gray': 'v2-text-gray-600',
      'medium-gray': 'v2-text-grayscale-80',
      'dark-gray': 'v2-text-grayscale-96',
      silver: 'v2-text-silver',
      danger: 'v2-text-red-500',
    },
  },
});

const TextSmall = ({ children, className, variant = 'dark' }: TextSmallProps) => {
  return (
    <p
      className={cn(
        textSmallStyles({
          color: variant,
        }),
        'v2-font-thin v2-font-sweet-sans-pro v2-leading-[1.125rem] sm:v2-text-[0.7rem] md:v2-text-[0.75rem] lg:v2-text-[0.8125rem] xs:v2-text-[0.65rem] xxs:v2-text-[0.65rem]',
        className
      )}
    >
      {children}
    </p>
  );
};

export default TextSmall;
